import { render } from "./GetProductRecentInventory.vue?vue&type=template&id=397c1aff"
import script from "./GetProductRecentInventory.vue?vue&type=script&lang=js"
export * from "./GetProductRecentInventory.vue?vue&type=script&lang=js"
script.render = render

export default script